import React from "react";
import classNames from "classnames";
import styles from "./shot-map-shot-selector.module.scss";
import {observer} from "mobx-react";
import {ShotMapShotSelectorTimeAndType} from "./shot-map.shot-selector.time-and-type";
import {GameShotChartWidgetSelectorPlayer} from "../../../../widgets/game-shot-chart-widget/components/shots-selector/game-shot-chart.widget.selector.player";

export const ShotMapShotSelectorContent = observer(({
                                                      controller,
                                                      selectedShot,
                                                      shouldRenderTypeShot,
                                                      isShallowShotMapView,
                                                      shouldRenderPlayer
                                                    }) => {
  const timeProps = {
    selectedShot,
    shouldRenderTypeShot,
    isShallowShotMapView
  }

  const playerProps = {
    controller,
    selectedShot,
    isShallowShotMapView
  }

  return (
      <div className={classNames(styles.content)}>
        {shouldRenderPlayer ? <GameShotChartWidgetSelectorPlayer {...playerProps}/> : null}
        <ShotMapShotSelectorTimeAndType {...timeProps}/>
      </div>
  )
});